module.exports = __webpack_public_path__ + "static/img/icon_status2.bcabccf6.png";